import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=06012d60&"
import script from "./AddUserModal.vue?vue&type=script&lang=js&"
export * from "./AddUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports